export const LABELS = {
  TITLE: 'Identification documents deleted',
  SUBTITLE:
    'Sorted takes the security of your data seriously, due to inactivity on our platform and in accordance with our security policy, we have deleted your sensitive identification documents',
  BUTTON: 'Dismiss',
};
